import { render, staticRenderFns } from "./productSearch.vue?vue&type=template&id=337afbc8&scoped=true"
import script from "./productSearch.vue?vue&type=script&lang=js"
export * from "./productSearch.vue?vue&type=script&lang=js"
import style0 from "./productSearch.vue?vue&type=style&index=0&id=337afbc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337afbc8",
  null
  
)

export default component.exports